import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { TelemetryLayer } from "by/gamefactory/scene/layer/TelemetryLayer";
import { Container, IDestroyOptions, Ticker, UPDATE_PRIORITY } from "pixi.js";
import { HiddenInputZone } from "./HiddenInputZone";
import { DetailsView } from "./DetailsView";
import { ShortInfo } from "./ShortInfo";

export class TelemetryView extends Container {
    private static readonly HOLD_TIME = 1000;

    private readonly telemetryLayer: TelemetryLayer;
    private readonly canvasScaler: ICanvasScaler;
    private readonly ticker: Ticker;

    private hiddenInput: HiddenInputZone;

    private detailsView: DetailsView;
    private shortInfo: ShortInfo;

    private fps: number;
    private framesTime: number;
    private framesCount: number;

    public constructor(
        telemetryLayerProvider: TelemetryLayer,
        canvasScaler: ICanvasScaler
    ) {
        super();
        this.telemetryLayer = telemetryLayerProvider;
        this.canvasScaler = canvasScaler;
        this.ticker = Ticker.shared;
        this.fps = 0;
        this.framesTime = 0;
        this.framesCount = 0;

        this.build();
        this.telemetryLayer.addChild(this);
        Ticker.shared.add(this.onTick, this, UPDATE_PRIORITY.UTILITY);
        this.hiddenInput.onClick.add(this.onHiddenZoneClick, this);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        Ticker.shared.remove(this.onTick, this);
        super.destroy(options);
    }

    private build(): void {
        this.detailsView = new DetailsView(this.canvasScaler);
        this.addChild(this.detailsView);

        this.shortInfo = new ShortInfo();
        this.addChild(this.shortInfo);
        this.shortInfo.show();

        this.hiddenInput = new HiddenInputZone(200, 85, TelemetryView.HOLD_TIME);
        this.addChild(this.hiddenInput);

        this.shortInfo.position.set(10, this.canvasScaler.referenceHeight - this.shortInfo.height);
        this.hiddenInput.position.set(0, this.canvasScaler.referenceHeight - this.hiddenInput.height);
    }

    private onTick(): void {
        this.framesCount++;
        this.framesTime += this.ticker.elapsedMS;

        //@ts-ignore
        const performance: { totalJSHeapSize?: number, usedJSHeapSize?: number, jsHeapSizeLimit?: number } = window.performance?.memory;
        this.shortInfo.updateData(this.fps, performance?.usedJSHeapSize ?? 0, performance?.jsHeapSizeLimit ?? 0);

        if (this.framesTime >= 1000) {
            this.fps = this.framesCount;
            this.framesCount = 0;
            this.framesTime = 0;
        }
    }

    private onHiddenZoneClick(): void {
        this.detailsView.show();
    }
}